export const SUPPORT_LINKS = {
  TELEGRAM: 'https://t.me/mateline_support',
}
